require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./cljs.tools.reader.edn.js");

require("./com.wsscode.blog.components.ui.js");

require("./com.wsscode.misc.coll.js");

require("./com.wsscode.pathom3.connect.indexes.js");

require("./com.wsscode.pathom3.connect.planner.js");

require("./edn_query_language.core.js");

require("./helix.core.js");

require("./helix.dom.js");

require("./helix.hooks.js");

require("./promesa.core.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.blog.components.pathom_viz_embed.js");
goog.provide('com.wsscode.blog.components.pathom_viz_embed');
com.wsscode.blog.components.pathom_viz_embed.DEV_VIZ_QMARK_ = false;
com.wsscode.blog.components.pathom_viz_embed.embed_url = com.wsscode.blog.components.pathom_viz_embed.DEV_VIZ_QMARK_ ? "http://localhost:8087/embed.html" : "https://pathom-viz.wsscode.com/embed.html";

com.wsscode.blog.components.pathom_viz_embed.post_message = function com$wsscode$blog$components$pathom_viz_embed$post_message(window, message) {
  return window.postMessage({
    "event": "pathom-viz-embed",
    "payload": cljs.core.pr_str.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([message], 0))
  }, "*");
};

com.wsscode.blog.components.pathom_viz_embed.EmbedComponent = function () {
  var G__36250 = function com$wsscode$blog$components$pathom_viz_embed$EmbedComponent_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__36251 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var map__36254 = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36251, 0, null);
    var map__36254__$1 = (!(map__36254 == null) ? map__36254.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__36254.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__36254) : map__36254;
    var message = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__36254__$1, new cljs.core.Keyword(null, "message", "message", -406056002));
    var height = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__36254__$1, new cljs.core.Keyword(null, "height", "height", 1025178622));
    var iframe_ref = helix.hooks.use_ref(null);
    var vec__36256 = helix.hooks.use_state(false);
    var full_QMARK_ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36256, 0, null);
    var sf_BANG_ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36256, 1, null);
    var G__36259_36367 = helix.hooks.wrap_fx(function () {
      if (cljs.core.truth_(cljs.core.deref(iframe_ref))) {
        return cljs.core.deref(iframe_ref).addEventListener("load", function () {
          return com.wsscode.blog.components.pathom_viz_embed.post_message(cljs.core.deref(iframe_ref).contentWindow, message);
        });
      } else {
        return null;
      }
    });
    var G__36260_36368 = [iframe_ref];
    helix.hooks.raw_use_effect.cljs$core$IFn$_invoke$arity$2 ? helix.hooks.raw_use_effect.cljs$core$IFn$_invoke$arity$2(G__36259_36367, G__36260_36368) : helix.hooks.raw_use_effect.call(null, G__36259_36367, G__36260_36368);
    return helix.core.get_react().createElement("div", helix.impl.props.merge_obj({}, helix.impl.props._dom_props.cljs$core$IFn$_invoke$arity$1(new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "style", "style", -496642736), function () {
      var G__36263 = new cljs.core.PersistentArrayMap(null, 3, [new cljs.core.Keyword(null, "background", "background", -863952629), "#fff", new cljs.core.Keyword(null, "display", "display", 242065432), "flex", new cljs.core.Keyword(null, "flexDirection", "flexDirection", 1286039598), "column"], null);

      if (cljs.core.truth_(full_QMARK_)) {
        return cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([G__36263, new cljs.core.PersistentArrayMap(null, 3, [new cljs.core.Keyword(null, "position", "position", -2011731912), "fixed", new cljs.core.Keyword(null, "inset", "inset", -396367740), "0", new cljs.core.Keyword(null, "zIndex", "zIndex", -1588341609), "1000"], null)], 0));
      } else {
        return G__36263;
      }
    }()], null))), helix.core.get_react().createElement("button", function () {
      var obj36265 = {
        "onClick": function onClick() {
          var G__36266 = cljs.core.not(full_QMARK_);
          return sf_BANG_.cljs$core$IFn$_invoke$arity$1 ? sf_BANG_.cljs$core$IFn$_invoke$arity$1(G__36266) : sf_BANG_.call(null, G__36266);
        },
        "className": "embed-full-screen"
      };
      return obj36265;
    }(), cljs.core.truth_(full_QMARK_) ? "Leave Full Screen" : "Full Screen"), helix.core.get_react().createElement("iframe", function () {
      var obj36268 = {
        "src": com.wsscode.blog.components.pathom_viz_embed.embed_url,
        "ref": iframe_ref,
        "loading": "lazy",
        "style": function () {
          var obj36270 = {
            "flex": helix.impl.props.__GT_js("1"),
            "width": helix.impl.props.__GT_js("100%"),
            "height": helix.impl.props.__GT_js(cljs.core.truth_(full_QMARK_) ? "auto" : height),
            "border": helix.impl.props.__GT_js("0")
          };
          return obj36270;
        }()
      };
      return obj36268;
    }()));
  };

  if (goog.DEBUG === true) {
    var G__36271 = G__36250;
    G__36271.displayName = "com.wsscode.blog.components.pathom-viz-embed/EmbedComponent";
    return G__36271;
  } else {
    return G__36250;
  }
}();

com.wsscode.blog.components.pathom_viz_embed.PlanStepperDemo = function () {
  var G__36273 = function com$wsscode$blog$components$pathom_viz_embed$PlanStepperDemo_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__36274 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var map__36277 = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36274, 0, null);
    var map__36277__$1 = (!(map__36277 == null) ? map__36277.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__36277.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__36277) : map__36277;
    var oir = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__36277__$1, new cljs.core.Keyword(null, "oir", "oir", 1620346896));
    var query = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__36277__$1, new cljs.core.Keyword(null, "query", "query", -1288509510));
    var available = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__36277__$1, new cljs.core.Keyword(null, "available", "available", -1470697127));
    return helix.core.get_react().createElement(com.wsscode.blog.components.pathom_viz_embed.EmbedComponent, function () {
      var obj36285 = {
        "message": new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("pathom.viz.embed", "component-name", "pathom.viz.embed/component-name", -1760625523), new cljs.core.Keyword("pathom.viz.embed.component", "plan-stepper-demo", "pathom.viz.embed.component/plan-stepper-demo", -2090815463), new cljs.core.Keyword("pathom.viz.embed", "component-props", "pathom.viz.embed/component-props", 1770305176), new cljs.core.PersistentArrayMap(null, 3, [new cljs.core.Keyword("com.wsscode.pathom3.connect.indexes", "index-oir", "com.wsscode.pathom3.connect.indexes/index-oir", -418434909), cljs.tools.reader.edn.read_string.cljs$core$IFn$_invoke$arity$1(oir), new cljs.core.Keyword("com.wsscode.pathom3.connect.planner", "available-data", "com.wsscode.pathom3.connect.planner/available-data", 727921292), function () {
          var or__4126__auto__ = function () {
            var G__36287 = available;

            if (G__36287 == null) {
              return null;
            } else {
              return cljs.tools.reader.edn.read_string.cljs$core$IFn$_invoke$arity$1(G__36287);
            }
          }();

          if (cljs.core.truth_(or__4126__auto__)) {
            return or__4126__auto__;
          } else {
            return cljs.core.PersistentArrayMap.EMPTY;
          }
        }(), new cljs.core.Keyword("edn-query-language.core", "query", "edn-query-language.core/query", -1940317492), cljs.tools.reader.edn.read_string.cljs$core$IFn$_invoke$arity$1(query)], null)], null),
        "height": "500px"
      };
      return obj36285;
    }());
  };

  if (goog.DEBUG === true) {
    var G__36288 = G__36273;
    G__36288.displayName = "com.wsscode.blog.components.pathom-viz-embed/PlanStepperDemo";
    return G__36288;
  } else {
    return G__36273;
  }
}();

goog.exportSymbol('com.wsscode.blog.components.pathom_viz_embed.PlanStepperDemo', com.wsscode.blog.components.pathom_viz_embed.PlanStepperDemo);

com.wsscode.blog.components.pathom_viz_embed.use_edn_file = function com$wsscode$blog$components$pathom_viz_embed$use_edn_file(path) {
  var vec__36290 = helix.hooks.use_state(new cljs.core.Keyword("com.wsscode.blog.components.ui", "loading", "com.wsscode.blog.components.ui/loading", -911961282));
  var contents = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36290, 0, null);
  var c_BANG_ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36290, 1, null);
  var G__36294_36369 = helix.hooks.wrap_fx(function () {
    return promesa.core.catch$.cljs$core$IFn$_invoke$arity$2(promesa.protocols._bind(promesa.protocols._promise(null), function (___23891__auto__) {
      return promesa.protocols._bind(promesa.protocols._promise(fetch(path)), function (res) {
        return promesa.protocols._bind(promesa.protocols._promise(res.text()), function (txt) {
          return promesa.protocols._bind(promesa.protocols._promise(null), function (___23875__auto__) {
            return promesa.protocols._promise(function () {
              var G__36296 = cljs.tools.reader.edn.read_string.cljs$core$IFn$_invoke$arity$1(txt);
              return c_BANG_.cljs$core$IFn$_invoke$arity$1 ? c_BANG_.cljs$core$IFn$_invoke$arity$1(G__36296) : c_BANG_.call(null, G__36296);
            }());
          });
        });
      });
    }), function (p1__36289_SHARP_) {
      var G__36297 = new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.wsscode.blog.components.ui", "error", "com.wsscode.blog.components.ui/error", -887676017), p1__36289_SHARP_], null);
      return c_BANG_.cljs$core$IFn$_invoke$arity$1 ? c_BANG_.cljs$core$IFn$_invoke$arity$1(G__36297) : c_BANG_.call(null, G__36297);
    });
  });
  var G__36295_36370 = [path];
  helix.hooks.raw_use_effect.cljs$core$IFn$_invoke$arity$2 ? helix.hooks.raw_use_effect.cljs$core$IFn$_invoke$arity$2(G__36294_36369, G__36295_36370) : helix.hooks.raw_use_effect.call(null, G__36294_36369, G__36295_36370);
  return contents;
};

com.wsscode.blog.components.pathom_viz_embed.PlanStepperFile = function () {
  var G__36300 = function com$wsscode$blog$components$pathom_viz_embed$PlanStepperFile_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__36301 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var map__36304 = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36301, 0, null);
    var map__36304__$1 = (!(map__36304 == null) ? map__36304.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__36304.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__36304) : map__36304;
    var path = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__36304__$1, new cljs.core.Keyword(null, "path", "path", -188191168));
    return com.wsscode.blog.components.ui.loader(com.wsscode.blog.components.pathom_viz_embed.use_edn_file(path), function (p1__36298_SHARP_) {
      return helix.core.get_react().createElement(com.wsscode.blog.components.pathom_viz_embed.EmbedComponent, function () {
        var obj36310 = {
          "message": new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("pathom.viz.embed", "component-name", "pathom.viz.embed/component-name", -1760625523), new cljs.core.Keyword("pathom.viz.embed.component", "plan-snapshots", "pathom.viz.embed.component/plan-snapshots", -604963237), new cljs.core.Keyword("pathom.viz.embed", "component-props", "pathom.viz.embed/component-props", 1770305176), p1__36298_SHARP_], null),
          "height": "500px"
        };
        return obj36310;
      }());
    });
  };

  if (goog.DEBUG === true) {
    var G__36311 = G__36300;
    G__36311.displayName = "com.wsscode.blog.components.pathom-viz-embed/PlanStepperFile";
    return G__36311;
  } else {
    return G__36300;
  }
}();

goog.exportSymbol('com.wsscode.blog.components.pathom_viz_embed.PlanStepperFile', com.wsscode.blog.components.pathom_viz_embed.PlanStepperFile);

com.wsscode.blog.components.pathom_viz_embed.PlanGraphFile = function () {
  var G__36314 = function com$wsscode$blog$components$pathom_viz_embed$PlanGraphFile_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__36315 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var map__36318 = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36315, 0, null);
    var map__36318__$1 = (!(map__36318 == null) ? map__36318.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__36318.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__36318) : map__36318;
    var path = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__36318__$1, new cljs.core.Keyword(null, "path", "path", -188191168));
    return com.wsscode.blog.components.ui.loader(com.wsscode.blog.components.pathom_viz_embed.use_edn_file(path), function (p1__36312_SHARP_) {
      return helix.core.get_react().createElement(com.wsscode.blog.components.pathom_viz_embed.EmbedComponent, function () {
        var obj36321 = {
          "message": new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("pathom.viz.embed", "component-name", "pathom.viz.embed/component-name", -1760625523), new cljs.core.Keyword("pathom.viz.embed.component", "plan-view", "pathom.viz.embed.component/plan-view", -2086329312), new cljs.core.Keyword("pathom.viz.embed", "component-props", "pathom.viz.embed/component-props", 1770305176), p1__36312_SHARP_], null),
          "height": "500px"
        };
        return obj36321;
      }());
    });
  };

  if (goog.DEBUG === true) {
    var G__36322 = G__36314;
    G__36322.displayName = "com.wsscode.blog.components.pathom-viz-embed/PlanGraphFile";
    return G__36322;
  } else {
    return G__36314;
  }
}();

goog.exportSymbol('com.wsscode.blog.components.pathom_viz_embed.PlanGraphFile', com.wsscode.blog.components.pathom_viz_embed.PlanGraphFile);

com.wsscode.blog.components.pathom_viz_embed.PlanGraphFileWithDetails = function () {
  var G__36325 = function com$wsscode$blog$components$pathom_viz_embed$PlanGraphFileWithDetails_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__36326 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var map__36329 = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36326, 0, null);
    var map__36329__$1 = (!(map__36329 == null) ? map__36329.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__36329.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__36329) : map__36329;
    var path = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__36329__$1, new cljs.core.Keyword(null, "path", "path", -188191168));
    return com.wsscode.blog.components.ui.loader(com.wsscode.blog.components.pathom_viz_embed.use_edn_file(path), function (p1__36323_SHARP_) {
      return helix.core.get_react().createElement(com.wsscode.blog.components.pathom_viz_embed.EmbedComponent, function () {
        var obj36338 = {
          "message": new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("pathom.viz.embed", "component-name", "pathom.viz.embed/component-name", -1760625523), new cljs.core.Keyword("pathom.viz.embed.component", "plan-view-with-details", "pathom.viz.embed.component/plan-view-with-details", 1717107549), new cljs.core.Keyword("pathom.viz.embed", "component-props", "pathom.viz.embed/component-props", 1770305176), p1__36323_SHARP_], null),
          "height": "500px"
        };
        return obj36338;
      }());
    });
  };

  if (goog.DEBUG === true) {
    var G__36339 = G__36325;
    G__36339.displayName = "com.wsscode.blog.components.pathom-viz-embed/PlanGraphFileWithDetails";
    return G__36339;
  } else {
    return G__36325;
  }
}();

goog.exportSymbol('com.wsscode.blog.components.pathom_viz_embed.PlanGraphFileWithDetails', com.wsscode.blog.components.pathom_viz_embed.PlanGraphFileWithDetails);

com.wsscode.blog.components.pathom_viz_embed.PlannerExplorer = function () {
  var G__36341 = function com$wsscode$blog$components$pathom_viz_embed$PlannerExplorer_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__36345 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var map__36348 = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36345, 0, null);
    var map__36348__$1 = (!(map__36348 == null) ? map__36348.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__36348.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__36348) : map__36348;
    var oir = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__36348__$1, new cljs.core.Keyword(null, "oir", "oir", 1620346896));
    var query = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__36348__$1, new cljs.core.Keyword(null, "query", "query", -1288509510));
    return helix.core.get_react().createElement(com.wsscode.blog.components.pathom_viz_embed.EmbedComponent, function () {
      var obj36357 = {
        "message": new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("pathom.viz.embed", "component-name", "pathom.viz.embed/component-name", -1760625523), new cljs.core.Keyword("pathom.viz.embed.component", "planner-explorer", "pathom.viz.embed.component/planner-explorer", 21127885), new cljs.core.Keyword("pathom.viz.embed", "component-props", "pathom.viz.embed/component-props", 1770305176), new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword("com.wsscode.pathom3.connect.indexes", "index-oir", "com.wsscode.pathom3.connect.indexes/index-oir", -418434909), cljs.tools.reader.edn.read_string.cljs$core$IFn$_invoke$arity$1(oir), new cljs.core.Keyword("edn-query-language.core", "query", "edn-query-language.core/query", -1940317492), cljs.tools.reader.edn.read_string.cljs$core$IFn$_invoke$arity$1(query)], null)], null),
        "height": "760px"
      };
      return obj36357;
    }());
  };

  if (goog.DEBUG === true) {
    var G__36358 = G__36341;
    G__36358.displayName = "com.wsscode.blog.components.pathom-viz-embed/PlannerExplorer";
    return G__36358;
  } else {
    return G__36341;
  }
}();

goog.exportSymbol('com.wsscode.blog.components.pathom_viz_embed.PlannerExplorer', com.wsscode.blog.components.pathom_viz_embed.PlannerExplorer);

com.wsscode.blog.components.pathom_viz_embed.PlanView = function () {
  var G__36360 = function com$wsscode$blog$components$pathom_viz_embed$PlanView_render(props__21282__auto__, maybe_ref__21283__auto__) {
    var vec__36361 = new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [helix.core.extract_cljs_props(props__21282__auto__), maybe_ref__21283__auto__], null);
    var message = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__36361, 0, null);
    return helix.core.get_react().createElement(com.wsscode.blog.components.pathom_viz_embed.EmbedComponent, function () {
      var obj36365 = {
        "message": com.wsscode.misc.coll.update_if.cljs$core$IFn$_invoke$arity$3(cljs.core.assoc.cljs$core$IFn$_invoke$arity$variadic(message, new cljs.core.Keyword(null, "message", "message", -406056002), "pathom-start-embed", cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword(null, "component", "component", 1555936782), "plan-view"], 0)), new cljs.core.Keyword(null, "plan", "plan", 1118952668), cljs.tools.reader.edn.read_string),
        "height": "500px"
      };
      return obj36365;
    }());
  };

  if (goog.DEBUG === true) {
    var G__36366 = G__36360;
    G__36366.displayName = "com.wsscode.blog.components.pathom-viz-embed/PlanView";
    return G__36366;
  } else {
    return G__36360;
  }
}();

goog.exportSymbol('com.wsscode.blog.components.pathom_viz_embed.PlanView', com.wsscode.blog.components.pathom_viz_embed.PlanView);
Object.defineProperty(module.exports, "PlanGraphFile", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.PlanGraphFile;
  }
});
Object.defineProperty(module.exports, "PlanStepperDemo", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.PlanStepperDemo;
  }
});
Object.defineProperty(module.exports, "use_edn_file", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.use_edn_file;
  }
});
Object.defineProperty(module.exports, "EmbedComponent", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.EmbedComponent;
  }
});
Object.defineProperty(module.exports, "PlanGraphFileWithDetails", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.PlanGraphFileWithDetails;
  }
});
Object.defineProperty(module.exports, "DEV_VIZ_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.DEV_VIZ_QMARK_;
  }
});
Object.defineProperty(module.exports, "PlanStepperFile", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.PlanStepperFile;
  }
});
Object.defineProperty(module.exports, "PlanView", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.PlanView;
  }
});
Object.defineProperty(module.exports, "PlannerExplorer", {
  enumerable: true,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.PlannerExplorer;
  }
});
Object.defineProperty(module.exports, "post_message", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.post_message;
  }
});
Object.defineProperty(module.exports, "embed_url", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.components.pathom_viz_embed.embed_url;
  }
});